export class TecnicaModel {

    filtro_data_inicial: Date
    filtro_data_final: Date

    cod_chamada?: string
    coligada?: string
    cod_cliente?: string       
    visita?: string
    saida?: string
    tipo_equipamento?:string
    elevador?: string
    resolvido?: string
    resolvido_nova1?: string
    resolvido_nova?: string
    cliente?: string
    data?: Date
    descricaoTitulo?: string
    qtd?: string
    mec?: string
    setor?: string
    grupo?: string
   
    QtdClientes?: number
    QtdEscada?: number
    QtdPlataforma?: number

    Resolvidos?: number
    NaoResolvidos?: number
    total_atendimento?: number

    protocolo?: string
    hora?: string
    reclamante?: string
    defeito?: string

    Color?: string

   TotalDia?: number
    AtendeSIM?: number
    AtendeNAO?: number

}